class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    
    this.mainDetailsToggle.addEventListener("toggle", event => {
        console.log(this.mainDetailsToggle)
        if (this.mainDetailsToggle.open) {
        console.log( this.mainDetailsToggle.closest('.new-category'));
          var elements = document.getElementsByTagName ('details');
          for(const element of elements){
            if(element.id != this.mainDetailsToggle.id){
               element.removeAttribute('open');
            }
           
          }
        }
      });
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  close() {
    //this.mainDetailsToggle.removeAttribute('open');
   // this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    console.log('close');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
